import i18n from "i18next";
import HttpBackend from "i18next-http-backend";

import { initReactI18next } from "react-i18next";

import {
  DEFAULT_LANGUAGE,
  fromLegacyCode,
  toCpqLocale,
} from "./utils/languages";

// The UI dictionary context the backend serves the webshop texts under.
// Matches the `contextId` path segment of getUiTranslations.
const NAMESPACE = "CustomApp";

// Dirty fix - remove "currentLanguage" from localStorage if cookie "languageId" doesn't exist.
if (document.cookie.indexOf("languageId") < 0) {
  localStorage.removeItem("currentLanguage");
}

// older sessions stored legacy backend codes ("si", "se"); keep ISO only
const storedLanguage = localStorage.getItem("currentLanguage");
const language = storedLanguage
  ? fromLegacyCode(storedLanguage)
  : DEFAULT_LANGUAGE;
if (storedLanguage && storedLanguage !== language) {
  localStorage.setItem("currentLanguage", language);
}

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.DEV,
    //debug: true,
    lng: language,
    // The backend already answers unmaintained locales with the English
    // dictionary, so a client-side fallback would only add a second request.
    // load: "currentOnly" stops i18next from also requesting the bare
    // language of a region code ("de" next to "de-DE").
    fallbackLng: false,
    load: "currentOnly",

    ns: [NAMESPACE],
    defaultNS: NAMESPACE,

    backend: {
      // the dictionary only resolves some short codes ("de" works, "cs"
      // silently returns English), so always request the full locale id
      loadPath: (lngs, namespaces) =>
        `/api/3pq-cs/v2/configuration/uiTranslations/${toCpqLocale(lngs[0])}/${namespaces[0]}`,
    },

    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    keySeparator: false,
    joinArrays: false,
    returnObjects: false,

    // react i18next special options (optional)
    react: {
      // t() calls carry no default values, so rendering before the
      // dictionary arrives would show raw keys - suspend until it's loaded
      useSuspense: true,
      nsMode: "default", // set it to fallback to let passed namespaces to translated hoc act as fallbacks
    },
  });

document.documentElement.lang = language;
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export { i18n };
